import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import moment from "moment";
import TickImage from "./TickImage";
import Cookies from "js-cookie";
import initiatedIcon from '../assets/images/initiated.svg';
import processingIcon from '../assets/images/processing.svg';
import partiallyProcessedIcon from '../assets/images/partially_processed.svg';
import processedIcon from '../assets/images/processed.svg';
import scheduledIcon from '../assets/images/sechdule.svg';
import emptyIcon from '../assets/images/empty.svg';
import failedIcon from '../assets/images/failed.svg';
import { dashboardColors, theme } from "../themes/Theme";
import DOMPurify from 'dompurify';
import { baseUrl, oauthDomain, webClientId } from "../config/config";
import { sanitizeHTML } from "../revampComponents/RichTextEditor/utils/tinymce.cleaner";
toast.configure();

//quiz
export const ADMIN_EMAIL = "olympus@codeops.tech"; //'manjunath.r@knownshare.in';
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const OWNER = "owner";
export const COLLABORATOR = "collaborator";
export const READER = "reader";
export const SOFT_DELETED = "soft-deleted";
export const ENDED = "ended";
export const ABANDONED = "abandoned";
export const PENDING = "pending";
export const STARTED = "started";
export const REGULAR = "regular";
export const DISCOUNT_CODE = "Discount Code";
export const ACCESS_CODE = "Access Code";
export const GROUP_DISCOUNT_CODE = "Group Discount";
export const AVAILABLE = "Available";
export const EXPIRED = "Expired";
export const EXHAUSTED = "Exhausted";

export const ENTITY_NAME_SCHEMA_REGEX = /^[-:()\[\]|,`~#\/<>.&@+'\p{L}\p{N}\s!$%^*={}\[\];?\\]+$/u;

export const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/;

export const accessType = [
	{ value: 1, label: "Collaborator (All Access - Same as Owner)" },
	{ value: 2, label: "Reader (Limited Access - View, No Edit & No Delete)" }
];

export const pgMethods = {
	1: "RAZORPAY",
	2: "STRIPE",
	3: "OPENBANK",
	4: "PHONEPE",
	5: "TAP",
	6: "COPPERX"
};

export const getStatus = (startDateTime, endDateTime, status = "", mode = "") => {
	if (status === "pending") return "Upcoming";
	if (status === "started") return "Live";
	if (status === "ended" || status === "abandoned") return "Expired";
	if (status === "soft-deleted") return "Deleted";
	if (moment().isAfter(moment.utc(endDateTime).local())) return "Expired";
	if (moment().isBetween(moment.utc(startDateTime).local(), moment.utc(endDateTime).local()))
		return "Live";
	else return "Upcoming";
};

export const makeCSV = content => {
	let csv = "";
	content.forEach(value => {
		value.forEach((item, i) => {
			const innerValue = !item ? "" : item.toString();
			let result = innerValue.replace(/"/g, '""');
			if (result.search(/("|,|\n)/g) >= 0) {
				result = '"' + result + '"';
			}
			if (i > 0) {
				csv += ",";
			}
			csv += result;
		});
		csv += "\n";
	});
	return csv;
};

export const logout = async () => {
	try {
		localStorage.removeItem("jwtToken");
		localStorage.removeItem("userEmail");
		localStorage.removeItem("userName");
		localStorage.removeItem("user");
		localStorage.removeItem("eventId");
		for (const key in localStorage) {
			if (key.includes("CognitoIdentityServiceProvider")) {
				localStorage.removeItem(key);
			}
		}
		const _cookies = Cookies.get();
		const domains = [
			"localhost",
			".konfhub.com",
		]; // Specify the domains
		const path = "/";
		Object.keys(_cookies).forEach(key => {
			if (key.includes("CognitoIdentityServiceProvider")) {
				domains.forEach(domain => {
					Cookies.remove(key, { path, domain });
					localStorage.removeItem(key);
					localStorage.clear();
				});
			}
		});
		Auth.signOut({ global: true });

		// 2. Trigger Cognito logout silently via hidden iframe
		const iframe = document.createElement("iframe");
		iframe.style.display = "none";
		iframe.src = `${oauthDomain}/logout?client_id=${webClientId}&logout_uri=${encodeURIComponent(baseUrl)}`;
		document.body.appendChild(iframe);

		// 3. Optional: clean up iframe after a short delay
		setTimeout(() => {
			iframe.remove();
		}, 3000);
	} catch (err) {
		console.log(err);
	}
};

export const successToaster = (message, autoClose = 5000, id = false) => {
	toast.success(message, {
		position: "top-right",
		autoClose: autoClose,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		style: { paddingRight: '10px' },
		...(id && { toastId: id })
	});
};

export const errorToaster = (message, autoClose = 5000, id = false) => {
	toast.error(message, {
		position: "top-right",
		autoClose: autoClose,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		style: { paddingRight: '10px' },
		...(id && { toastId: id })
	});
};

export const scrollToErrorMessage = (errors) => {
	if (errors && Object.keys(errors).length > 0) {
		const errorElement = document.querySelector(".error-message");
		errorElement?.scrollIntoView({ behavior: "smooth", block: "center" });
	}
}

export const clickOutside = (ref, onClickOutside) => {
	// Function to close dropdown when clicked anywhere outside
	useEffect(() => {
		/**
		 * Invoke Function onClick outside of element
		 */
		function handleClickOutside(event) {
			if (ref?.current && !ref?.current?.contains(event.target)) {
				onClickOutside();
			}
		}
		if (ref?.current) {
			// Bind
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				// dispose
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}
	}, [ref, onClickOutside]);
};

// A custom hook that builds on useLocation to parse the query string for you.
export function useQuery() {
	const { search } = useLocation();

	const params = Object.fromEntries(React.useMemo(() => new URLSearchParams(search), [search]));

	return params;
}

export const regexMethods = {
	//This is used for certaing regex operation
	allowOnlyPositiveNumber: evt => {
		const charCode = String.fromCharCode(evt.which);
		if (!/[0-9]/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	allowAlphaNumeric: evt => {
		const charCode = String.fromCharCode(evt.which);
		if (!/^[a-z0-9-]+/i.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	allowAlphaNumericAndSpecial: evt => {
		//alphanumeric and accpet special characters :- @, &, #, $, !, (, ), *
		const charCode = String.fromCharCode(evt.which);
		if (!/^[a-zA-Z0-9@&#$!()*-]+$/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	noSpaces: evt => {
		const charCode = String.fromCharCode(evt.which);
		if (!/^\S*$/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	noSpaceEmptyBox: evt => {
		const char = String.fromCharCode(evt.which);
		const currentValue = evt.target.value;
		if (currentValue.trim() === '' && char === ' ') {
			evt.preventDefault();
		}
	},
	numbersAnsDecimal: evt => {
		const charCode = String.fromCharCode(evt.which);
		if (!/^\d*\.?\d*$/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	}
};

export const paymentMethods = payment_method => {
	const PAYMENT_METHOD_TYPES = {
		1: "UPI",
		2: "Cards", //Card rzp
		3: "Net Banking",
		4: "Cards-stripe",
		5: "Wallet",
		6: "Stripe-pg",
		7: "Tap",
		8: "CopperX"
	};
	return PAYMENT_METHOD_TYPES[payment_method];
};

export const paymentGateway = {
	copperX: 8
}

export const TRANSACTION_TYPES = {
	"LEAD": 1,
	"ACTIVE": 2,
	"CANCEL": 3,
	"PARTIAL_REFUND": 4,
	"COMPLETE_REFUND": 5,
	"WAITLIST": 6,
	"WAITLIST_APPROVED": 7,
	"WAITLIST_REJECTED": 8,
	"EDIT_ATTENDEE": 9,
	"FORWARD_ATTENDEE": 10,
	"DOWNLOAD_REGISTRATION": 11,
	"SETTLEMENT": 12,
	"PAYOUT": 13,
	"WAITLIST_DELETED": 14,
	"AMOUNT_FORWARDED": 15,
	"APPROVAL_PENDING": 16,
	"APPROVAL_APPROVED": 17,
	"APPROVAL_REJECTED": 18,
	"APPROVAL_DELETED": 19,
	"APPROVAL_ON_HOLD": 20,
	"FUND_ORDER_CREATED": 21,
	"FUND_ORDER_CAPTURED": 22,
	"REFUND_FROM_FUND": 23,
	"EDIT_WAITLIST": 24,
	"EDIT_APPROVAL": 25,
	"ONDEMAND_SETTLEMENT": 26,
	"SETTLEMENT_SERVICE_CHARGE": 27,
	"CREDIT_ORDER_CREATED": 28,
	"CREDIT_ORDER_CAPTURED": 29,
	"CREDIT_ORDER_FAILED": 30,
	"FUND_ORDER_FAILED": 31,
	"CREDIT_TRANSFERRED_TO": 32,
	"CREDIT_TRANSFERRED_FROM": 33,
	"CREDIT_COMPLIMENTARY": 34,
	"EXTERNAL_PG_ATTENDEE_TXN": 35,
};

export function replaceAll(string, search, replace) {
	// replaceAll alternative as replaceAll doesnt work while deploying
	return string.split(search).join(replace);
}

export const silverPlanFeaturesDomestic = [
	<li key="silver-domestic-1"><TickImage />Upto 2500 Attendees per Event **</li>,
	<li key="silver-domestic-2"><TickImage />Supports All Available Payment Methods</li>,
	<li key="silver-domestic-3"><TickImage />Non-INR Tickets are supported at <b>5% + GST</b> per Ticket</li>,
	<li key="silver-domestic-4"><TickImage />Approval Based Registrations</li>,
	<li key="silver-domestic-5"><TickImage />Group Discounts</li>,
	<li key="silver-domestic-6"><TickImage />Ticket Categories</li>,
	<li key="silver-domestic-7"><TickImage />Hidden Tickets</li>,
	<li key="silver-domestic-8"><TickImage />Customized Emails (with KonfHub Headers & footers)</li>,
	<li key="silver-domestic-9"><TickImage />Upto 10 Email Campaigns to Participants (KonfHub Headers & Footers)</li>,
	<li key="silver-domestic-10"><TickImage />Automated Referral Contests</li>,
	<li key="silver-domestic-11"><TickImage />3 Event Page Templates</li>,
	<li key="silver-domestic-12"><TickImage />QuizHub Free Version with 100 Live Participants per Quiz (Limited)</li>,
	<li key="silver-domestic-13"><TickImage />Collect Audience Feedback and issue Standard Certificates</li>,
	<li key="silver-domestic-14"><TickImage />Webhook</li>,
	<li key="silver-domestic-15"><TickImage />Developer Integrations (Registration API, Registration Button, Widget)</li>,
	<li key="silver-domestic-16"><TickImage />Check-in App</li>,
	<li key="silver-domestic-17"><TickImage />Sponsor App</li>,
	<li key="silver-domestic-18"><TickImage />Phone & Email Support (Working Days - 10 am to 7 pm IST)</li>
];

export const LitePlanFeaturesDomestic = [
	<li key="lite-domestic-1"><TickImage />Upto 300 Attendees per Event **</li>,
	<li key="lite-domestic-2"><TickImage />Supports Only UPI Payment Method</li>,
	<li key="lite-domestic-3"><TickImage />Analytics Dashboard</li>,
	<li key="lite-domestic-4"><TickImage />Unlimited Discount Codes</li>,
	<li key="lite-domestic-5"><TickImage />Team-Based Registrations</li>,
	<li key="lite-domestic-6"><TickImage />Waitilisted Attendees</li>,
	<li key="lite-domestic-7"><TickImage />Bulk Upload Attendees (100 max)</li>,
	<li key="lite-domestic-8"><TickImage />Upto 3 Email Campaigns to Participants (KonfHub Headers & Footers)</li>,
	<li key="lite-domestic-9"><TickImage />Check-in App (Basic Features)</li>,
	<li key="lite-domestic-10"><TickImage />Email Support (Working Days - 10 am to 7 pm IST)</li>
];

export const GoldPlanFeaturesDomestic = [
	<li key="gold-domestic-1"><TickImage />Upto 5000 Attendees per Event **</li>,
	<li key="gold-domestic-2"><TickImage />GST (Tax) Invoices</li>,
	<li key="gold-domestic-3"><TickImage />Listing in Featured Events</li>,
	<li key="gold-domestic-4"><TickImage />Customized Emails (Custom Headers & Footers)</li>,
	<li key="gold-domestic-5"><TickImage />Unlimited Email Campaigns (Custom / Branded Headers & Footers)</li>,
	<li key="gold-domestic-6"><TickImage />Bring Your Own Email ID & Sender ID</li>,
	<li key="gold-domestic-7"><TickImage />Whitelabeling: Logo & Branding Changes</li>,
	<li key="gold-domestic-8"><TickImage />Collect Audience Feedback & issue Customized Certificates</li>,
	<li key="gold-domestic-9"><TickImage />Zaiper Integration</li>,
	<li key="gold-domestic-10"><TickImage />Priority Support over Phone & Email Support (Working Days - 10 am to 7 pm IST)</li>
];

export const silverPlanFeaturesInternational = [
	<li key="silver-int-1"><TickImage />Upto 2500 Attendees per Paid Event</li>,
	<li key="silver-int-2"><TickImage />Approval based registrations</li>,
	<li key="silver-int-3"><TickImage />Group discounts</li>,
	<li key="silver-int-4"><TickImage />Ticket categories</li>,
	<li key="silver-int-5"><TickImage />Hidden Tickets</li>,
	<li key="silver-int-6"><TickImage />Customized Emails (with KonfHub headers & footers)</li>,
	<li key="silver-int-7"><TickImage />Upto 10 Email Campaigns to Participants (KonfHub Headers & Footers)</li>,
	<li key="silver-int-8"><TickImage />Automated Referral Contests</li>,
	<li key="silver-int-9"><TickImage />3 Event Page Templates</li>,
	<li key="silver-int-10"><TickImage />QuizHub Free Version with 100 Live Participants per Quiz (Limited)</li>,
	<li key="silver-int-11"><TickImage />Collect Audience Feedback and issue Standard Certificates</li>,
	<li key="silver-int-12"><TickImage />Webhook</li>,
	<li key="silver-int-13"><TickImage />Developer Integrations (Registration API, Registration Button, Widget)</li>,
	<li key="silver-int-14"><TickImage />Check-in App</li>,
	<li key="silver-int-15"><TickImage />Sponsor App</li>,
	<li key="silver-int-16"><TickImage />Phone & Email Support (Working Days - 10am to 7pm IST)</li>
];

export const LitePlanFeaturesInternational = [
	<li key="lite-int-1"><TickImage />Upto 300 Attendees per Event **</li>,
	<li key="lite-int-2"><TickImage />Analytics Dashboard</li>,
	<li key="lite-int-3"><TickImage />Unlimited Discounts Codes</li>,
	<li key="lite-int-4"><TickImage />Team-based Registrations</li>,
	<li key="lite-int-5"><TickImage />Waitilisted Attendees</li>,
	<li key="lite-int-6"><TickImage />Bulk Upload Attendees (100 max)</li>,
	<li key="lite-int-7"><TickImage />Upto 3 Email Campaigns to Participants (KonfHub Headers & Footers)</li>,
	<li key="lite-int-8"><TickImage />Check-in App (Basic Features)</li>,
	<li key="lite-int-9"><TickImage />Email Support (Working Days - 10am to 7pm IST)</li>
];

export const GoldPlanFeaturesInternational = [
	<li key="gold-int-1"><TickImage />Upto 5000 Attendees per Event</li>,
	<li key="gold-int-2"><TickImage />Tax Invoices</li>,
	<li key="gold-int-3"><TickImage />Listing in Featured Events</li>,
	<li key="gold-int-4"><TickImage />Customized Emails (Custom headers & footers)</li>,
	<li key="gold-int-5"><TickImage />Unlimited Email Campaigns (Custom/branded headers & footers) Bring Your Own Email ID & Sender ID</li>,
	<li key="gold-int-6"><TickImage />Whitelabeling: Logo & branding changes</li>,
	<li key="gold-int-7"><TickImage />Collect Audience Feedback & issue Customized Certificates</li>,
	<li key="gold-int-8"><TickImage />Zaiper Integration</li>,
	<li key="gold-int-9"><TickImage />Priority Support over Phone & Email (Working Days - 10am to 7pm IST)</li>
];

export const restrictedLitePages = [
	"Payement Method",
	"No international ticket",
	"Only 3 Emails campaigns",
	"Referral Contest",
	"Quiz",
	"Feedback Forms",
	"Check-in App",
	"Sponsor App",
	"Email Templates",
	"Event Page Templates",
	"White Label",
	"Integrations",
	"Registeration Buttons",
	"Embed Tickets",
	"Webhooks"
];

export const NOTIFICATION_CAMPAIGN_STATUS = {
	"1": "INITIATED",
	"2": "PROCESSING",
	"3": "SCHEDULED",
	"4": "PROCESSED",
	"5": "PARTIALLY PROCESSED",
	"6": "FAILED",
	"7": "EMPTY"
}

export const couponTypes = {
	1: "Discount Code",
	2: "Access Code",
	3: "Group Discount"
}

export const FORM_TYPE = {
	AUTO_ASSIGN: 16,
}

export const ER_COLUMN_MAPPING = {
	ATTENDEE_CATEGORY: "attendee_category",
	ACCESS_CATEGORY: "access_category",
	CODE_TRACKING_ID: "code_tracking_id"
}

export const PREDEFINED_FORMS_OPTIONS = {
	attendee_category: ["Delegate", "VIP", "Sponsor", "Conference"],
	access_category: ["Expo", "VIP", "Conference"]
}


export const JS_TYPES = {
	STRING: "string",
	NUMBER: "number",
	BOOLEAN: "boolean",
	UNDEFINED: "undefined",
	OBJECT: "object",
	FUNCTION: "function",
	BIGINT: "bigint",
	SYMBOL: "symbol"
};
export const LOADER_THEME = {
	rainbow: {
		palette: {
			brand: dashboardColors[theme].primary,
		}
	}
};

export const ENTITY = {
	ENTITY_HISTORY: "history"
};

export const isImageFile = (fileName) => {
	return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(fileName);
};


export const COMPONENT_HEADINGS = {
	ATTENDEES: "Attendees",
	CHECKED_IN_ATTENDEES: "Checked-in Attendees",
	CHECK_IN_ACCESS: "Check-in Access",
};

export const formatNumber = (number) => {
	if (number >= 10000000 || number <= -10000000) {
		return (number / 10000000).toFixed(number % 10000000 === 0 ? 0 : 1) + " Cr";
	} else if (number >= 100000 || number <= -100000) {
		return (number / 100000).toFixed(number % 100000 === 0 ? 0 : 1) + " L";
	} else if (number >= 1000 || number <= -1000) {
		return (number / 1000).toFixed(number % 1000 === 0 ? 0 : 1) + " K";
	}
	return number.toLocaleString("en-IN");
};

export const TIME_FORMATS = {
	COMPACT: "DD MMM YY",
	STANDARD: "DD MMM YYYY",
	ISO: "YYYY-MM-DD",
	DISPLAY: "DD MMM",
};
export const PAYMENT_GATEWAY_TYPE = {
	STRIPE: 2,
	TAP: 5,
	COPPERX: 6,
	AREEBA: 7
}

export const PAYMENT_GATEWAY_NAME = {
	COPPERX: "Crypto Currency"
}

export const includeStripeSupportedCountries = [
	'AE', 'AF', 'AL', 'AM', 'CW', 'AO', 'AR', 'AU', 'AW', 'AZ',
	'BA', 'BB', 'BD', 'BG', 'BH', 'BI', 'BM', 'BN', 'BO', 'BR',
	'BS', 'BW', 'BY', 'BZ', 'CA', 'CD', 'CH', 'CL', 'CN', 'CO',
	'CR', 'CV', 'CZ', 'DJ', 'DK', 'DO', 'DZ', 'EG', 'ET', 'DE',
	'FJ', 'FK', 'GB', 'GE', 'GI', 'GM', 'GN', 'GT', 'GY', 'HK',
	'HN', 'HR', 'HT', 'HU', 'ID', 'IL', 'IN', 'IS', 'JM', 'JO',
	'JP', 'KE', 'KG', 'KH', 'KM', 'KR', 'KW', 'KY', 'KZ', 'LA',
	'LB', 'LK', 'LR', 'LS', 'MA', 'MD', 'MG', 'MK', 'MM', 'MN',
	'MO', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NG', 'NI',
	'NO', 'NP', 'NZ', 'OM', 'PA', 'PE', 'PG', 'PH', 'PK', 'PL',
	'PY', 'QA', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SE',
	'SG', 'SH', 'SL', 'SO', 'SR', 'ST', 'SZ', 'TH', 'TJ', 'TN',
	'TO', 'TR', 'TT', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ',
	'VN', 'VU', 'WS', 'CM', 'AG', 'SN', 'PF', 'YE', 'ZA', 'ZM'
];

export const includeTapSupportedCountries = [
	"BH",
	"EG",
	"JO",
	"KW",
	"LB",
	"OM",
	"QA",
	"SA",
	"AE"
]

export const includeAreebaSupportedCountries = [
	"EG", // Egypt
	"JO", // Jordan
	"LB", // Lebanon
	"QA", // Qatar
	"AE", // United Arab Emirates
	"IQ"  // Iraq
];


export const EMAIL_CAMPAIGN_ARCHITECTURE = {
	OlderFlow: 1,
	NewFlow: 2
};


export const CP_STATUS = {
	INITIATED: 1,
	PROCESSING: 2,
	SCHEDULED: 3,
	PROCESSED: 4,
	PARTIALLY_PROCESSED: 5,
	FAILED: 6,
	EMPTY: 7,
}

export const REVERSE_CP_STATUS = Object.entries(CP_STATUS).reduce((acc, [key, value]) => {
	acc[value] = key;
	return acc;
}, {});

export const olderArch_CP_STATUS = {
	SCHEDULED: "2",
	PROCESSED: "1",
}
export const removeEmptyObjects = (obj) => {
	return Object.entries(obj).reduce((acc, [key, value]) => {
		if (
			value && typeof value === 'object' && !Array.isArray(value)
		) {
			const cleaned = removeEmptyObjects(value);
			if (Object.keys(cleaned).length !== 0) {
				acc[key] = cleaned;
			}
		} else {
			acc[key] = value;
		}
		return acc;
	}, {});
};

export const removeEmptyValues = (data) => {
	if (Array.isArray(data)) {
		const cleanedArray = data
			.map(removeEmptyValues)
			.filter(
				(item) =>
					item !== null &&
					item !== undefined &&
					!(typeof item === 'string' && item.trim() === '') &&
					!(typeof item === 'object' && Object.keys(item).length === 0)
			);
		return cleanedArray.length ? cleanedArray : undefined;
	}

	if (data && typeof data === 'object') {
		const cleanedObject = Object.entries(data).reduce((acc, [key, value]) => {
			const cleanedValue = removeEmptyValues(value);
			const isEmpty =
				cleanedValue === null ||
				cleanedValue === undefined ||
				(typeof cleanedValue === 'string' && cleanedValue.trim() === '') ||
				(typeof cleanedValue === 'object' && Object.keys(cleanedValue).length === 0);

			if (!isEmpty) {
				acc[key] = cleanedValue;
			}

			return acc;
		}, {});
		return Object.keys(cleanedObject).length ? cleanedObject : undefined;
	}

	// Return primitives (numbers, booleans, strings that are not empty)
	if (
		data === null ||
		data === undefined ||
		(typeof data === 'string' && data.trim() === '')
	) {
		return undefined;
	}

	return data;
};

export const fetchValueForRoleId = (roleId = null, isEventProfile = false) => {
	if (roleId === 0) {
		return {
			label: "Super Admin",
			value: 0
		}
	}
	if (roleId === 1) {
		return {
			label: isEventProfile ? "Profile Creator" : "Event Creator",
			value: 1
		}
	}
	if (roleId === 2) {
		return {
			label: "Admin",
			value: 2
		}
	}
	else if (roleId == 3) {
		return {
			label: "Developer",
			value: 3
		}
	}
	else if (roleId == 4) {
		return {
			label: "Admin (No Downloads)",
			value: 4
		}
	}
	return null;
}
export const STATUS_ICON_MAP = {
	INITIATED: { icon: initiatedIcon, label: "Initiated", tooltipFull: "Initiated - The campaign has been initiated and is awaiting processing", tooltip: "The campaign has been initiated and is awaiting processing" },
	PROCESSING: { icon: processingIcon, label: "Processing", tooltipFull: "Processing - The campaign is currently being processed and notifications are being sent", tooltip: "The campaign is currently being processed and notifications are being sent" },
	PARTIALLY_PROCESSED: { icon: partiallyProcessedIcon, label: "Partially Processed", tooltipFull: "Partially Processed - The campaign has been processed, but some notifications failed to send", tooltip: "The campaign has been processed, but some notifications failed to send" },
	PROCESSED: { icon: processedIcon, label: "Processed", tooltipFull: "Processed - The campaign has been successfully processed, with all notifications sent", tooltip: "The campaign has been successfully processed, with all notifications sent" },
	SCHEDULED: { icon: scheduledIcon, label: "Scheduled", tooltipFull: "Scheduled - The campaign is scheduled to be sent at a future time", tooltip: "The campaign is scheduled to be sent at a future time" },
	EMPTY: { icon: emptyIcon, label: "Empty", tooltipFull: "Empty - The campaign has no recipients, so no notifications were sent", tooltip: "The campaign has no recipients, so no notifications were sent" },
	FAILED: { icon: failedIcon, label: "Failed", tooltipFull: "Failed - The campaign couldn't be launched due to an error", tooltip: "The campaign couldn't be launched due to an error" }
};
export const getMessageStatus = (statusString) => {
	if (typeof statusString !== 'string') return '';
	return statusString.split('|')[0];
}
export const convertEpochToTimestamp = (epoch, timeZone) => {
	return moment.unix(epoch).tz(timeZone).format('MMM DD, YYYY, hh:mm A');
};
export const convertEpochToTimestampSchedule = (epoch, timeZone) => {
	return moment.unix(epoch).tz(timeZone).format('MMM DD, YYYY, hh:mm A z');
};
export const EMAIL_CAMPAIGN_TIME_FORMATS = {
	FORMAT_TYPE_1: "h:mm A, DD MMM YY",
	FORMAT_TYPE_2: "YYYY-MM-DD HH:mm:ss",
	FORMAT_TYPE_3: "MMM DD, YYYY",
	FORMAT_TYPE_4: "MMM DD, YYYY hh:mm A",
};
export const getEventDateNTimeForEmailCamp = (date, eventTimeZone = "Asia/Kolkata") => {
	if (!date) return "N/A";

	return moment.utc(date).tz(eventTimeZone).format(EMAIL_CAMPAIGN_TIME_FORMATS.FORMAT_TYPE_4);
};

export const EVENT_ROLE_TYPE = {
	SUPER_ADMIN: 0,
	EVENT_CREATOR: 1,
	EVENT_ADMIN: 2,
	EVENT_DEVELOPER: 3,
	ADMIN_NO_DOWNLOADS: 4,
	CHECKIN_APP_REGISTRATION_STAFF: 5
}

export const formatDateToLocalTime = (dateStr, timeZone) => {
	return moment.tz(dateStr, "YYYY-MM-DD HH:mm:ss", timeZone).format("MMM DD, YYYY hh:mm A z");
};

export const formatDateToLocalTimeDate = (dateStr) => {
	return moment(dateStr, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY hh:mm A");
}


export const COLORS = [
	"#002E6E",
	"#2C41B9",
	"#2E88E9",
	"#95C1FF",
	"#783AA8",
	"#A319C3",
	"#7D3C98",
	"#E74C3C",
	"#1ABC9C",
	"#2ECC71",
	"#F1C40F",
	"#9B59B6",
	"#34495E",
	"#3498DB",
	"#E67E22",
	"#C0392B",
	"#16A085",
	"#8E44AD",
	"#7F8C8D",
	"#27AE60"
];

export const loadRazorpayScript = () => {
	return new Promise((resolve, reject) => {
		const existingScript = document.querySelector(`script[src="https://checkout.razorpay.com/v1/checkout.js"]`);
		if (existingScript) {
			resolve(true); // explicitly resolve with `true`
			return;
		}
		const script = document.createElement("script");
		script.src = "https://checkout.razorpay.com/v1/checkout.js";
		script.async = true;
		script.onload = () => resolve(true); // same here
		script.onerror = () => reject(false);
		document.body.appendChild(script);
	});
};

export const convertToUTCString = (dateInput) => {
	const date = new Date(dateInput);
	if (isNaN(date)) throw new Error("Invalid date");

	const pad = (n) => n.toString().padStart(2, '0');

	const year = date.getUTCFullYear();
	const month = pad(date.getUTCMonth() + 1);
	const day = pad(date.getUTCDate());
	const hours = pad(date.getUTCHours());
	const minutes = pad(date.getUTCMinutes());
	const seconds = pad(date.getUTCSeconds());

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const calculateGST = (amount) => {
	const num = Number(amount);
	if (isNaN(num) || num <= 0) return { gst: 0, total: 0 };
	const gst = num * 0.18;
	const total = num + gst;
	return {
		gst: gst.toFixed(2),
		total: total.toFixed(2),
	};
};

export const sanitizeString = (string) => sanitizeHTML(string);

export const paymentGatewayCharges = {
	"UPI": 1.18,
	"Cards": 3.54,
	"Net Banking": 3.54,
	"Wallets": 3.54
}

export const formatDateToLocalTimeEmail = (dateObj) =>
	dateObj ? dateObj.format("MMM DD, YYYY hh:mm A") : "";


export const convertToEventTimeZoneEmail = (date, eventDetails) =>
	date ? moment.utc(date).tz(eventDetails?.time_zone) : null;


export const isMigratedV1Campaign = (campaignId) => {
	if (!campaignId || typeof campaignId !== 'string') return false;
	return campaignId.startsWith('00000000');
};

export const getTicketNameFromFilter = (filterName = "") => {
	const parts = filterName.split("::");
	return parts.length === 2 ? parts[1] : filterName;
};

export const addGSTPercentage = (percentage) => {
	return percentage + "+GST";
}

export const PAYMENT_METHOD_TYPES = {
	UPI: 1,             // Unified Payments Interface
	CARD: 2,            // General card (credit/debit)
	NET_BANKING: 3,     // Net banking
	STRIPE_CARD: 4,     // Card via Stripe
	WALLET: 5,          // Digital wallet (Paytm, PhonePe, etc.)
	STRIPE_PG: 6,       // Stripe payment gateway
	TAP_PG: 7,          // Tap Payments gateway
	COPPERX_PG: 8,      // Copperx payment gateway
	AREEBA_PG: 9        // Areeba payment gateway
};

export const WIDGET_NAME_PATTERN = /^[-–—‒:()[\]|,’`~#\/<>.&@+'!\w\s$%^*={};?\\\u0600-\u06FF\u0750-\u077F\u0870-\u089F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u10E60-\u10E7F]+$/u

export function handlePasteSanitize(e, formik, fieldName) {
	e.preventDefault();
	const pasted = (e?.clipboardData || window?.clipboardData)?.getData("text") || "";

	// collapse multiple spaces → single space, then trim leading/trailing spaces
	const cleaned = pasted?.replace(/\s+/g, " ").trim();

	formik?.setFieldValue(fieldName, cleaned);
}

// Helper function to find the maximum order number in a list of items
export const getNextOrder = (items, orderKey) => {
	// If the items list is empty or undefined, the next order is 1.
	if (!items || items?.length === 0) {
		return 1;
	}

	// Find the maximum value of the specified orderKey
	const maxOrder = items.reduce((max, item) => {
		const order = item[orderKey] || 0; // Use 0 if the key doesn't exist
		return order > max ? order : max;
	}, 0);
	return maxOrder + 1;
};

export const TICKET_TYPES = {
	FREE: 1,
	PAID: 2,
	DONATION: 3
};
export const TICKET_PRICE_LIMIT = {
	MINIMUM_PRICE: 20,
};
export const safeDecode = (value) => {
  if (typeof value !== 'string') return value;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const safeEncode = (value) => {
  if (typeof value !== 'string') return value;
  try {
    return encodeURIComponent(value);
  } catch {
    return value;
  }
};
export const ATTENDEE_APP_TEMPLATES = {
	CLASSIC: 1,
	PROFESSIONAL: 2,
};
export const TEMPLATE_SLUG_MAP = {
	[ATTENDEE_APP_TEMPLATES.PROFESSIONAL]: "modern",
	[ATTENDEE_APP_TEMPLATES.CLASSIC]: "classic",
};